
import { PolicyEnablementPanel } from '@/features/policies/components/PolicyEnablementPanel'

/**
 * Panel-only wrapper for the Org settings → Policies tab. Renders the policy
 * control toggles (enablement panel) only — the policy CRUD list now lives on
 * the standalone Policies page (PoliciesOverview → PolicyList). Must contain no
 * hooks of its own so the isPersonal early-return stays Rules-of-Hooks safe.
 */
export function OrgPolicies({ orgId, canAdmin, isPersonal }: { orgId: string; canAdmin: boolean; isPersonal?: boolean }) {
  if (isPersonal) {
    return (
      <div className="empty-state fu">
        <div className="empty-icon">⬡</div>
        <div>Policies are not available on personal workspaces.</div>
        <div style={{ fontSize: '0.78rem', color: 'var(--text3)', marginTop: 6, maxWidth: 400, textAlign: 'center' }}>
          OPA policy enforcement requires a Business plan or above. Create an organisation to get started.
        </div>
        <a href="/billing" className="btn btn-ghost btn-sm" style={{ marginTop: 12 }}>
          View plans
        </a>
      </div>
    )
  }

  return <PolicyEnablementPanel orgId={orgId} canAdmin={canAdmin} />
}
